var React = require('react');

function Gatsby (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("title",{"key":0},"gatsby"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M256,31c-125.2,0-225,99.7-225,225s99.7,225,225,225s225-99.8,225-225S381.3,31,256,31z M79.9,257.9l174.2,174.1    C158.2,432.1,79.9,353.8,79.9,257.9z M295.1,428.2L83.9,216.8c17.6-78.3,88-137,172.1-137c56.4,0.2,109.4,27,142.8,72.4    l-25.4,21.5c-26.9-39.4-71.6-62.9-119.3-62.7c-61-0.4-115.3,38.3-135.1,95.9L303,391c45-15.7,80.2-54.8,90-101.8h-76.3V256h115.4    C432.1,340.1,373.4,410.6,295.1,428.2L295.1,428.2z"}))]));
}

Gatsby.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = Gatsby;

Gatsby.default = Gatsby;
